import { toRGBA } from "./utils";

const livly = [249, 135, 126];
const l = (opacity: number = 1) =>
  toRGBA(livly[0], livly[1], livly[2], opacity);

export default l;
